import type { ReactNode } from 'react';
import { Table } from 'antd';
import type { ColumnsType } from 'antd/es/table';

export interface Column<T> {
  key: string;
  header: ReactNode;
  cell: (row: T) => ReactNode;
  className?: string;
  width?: string | number;
}

interface DataTableProps<T> {
  data: T[];
  columns: Column<T>[];
  rowKey: (row: T) => string;
  onRowClick?: (row: T) => void;
  emptyState?: ReactNode;
  className?: string;
}

export function DataTable<T extends object>({
  data,
  columns,
  rowKey,
  onRowClick,
  emptyState,
  className,
}: DataTableProps<T>) {
  if (data.length === 0 && emptyState) return <>{emptyState}</>;

  const antCols: ColumnsType<T> = columns.map((col) => ({
    key: col.key,
    title: col.header,
    width: col.width,
    className: col.className,
    render: (_: unknown, row: T) => col.cell(row),
  }));

  return (
    <Table
      className={className}
      dataSource={data}
      columns={antCols}
      rowKey={rowKey}
      pagination={false}
      size="middle"
      onRow={onRowClick ? (record) => ({ onClick: () => onRowClick(record), style: { cursor: 'pointer' } }) : undefined}
    />
  );
}
